import React, {useMemo} from 'react'
import {useWhatChanged} from "../hooks/useWhatsChanged";


export const UploaderConfigContext = React.createContext({})
export const UploaderConfigProvider = (
  {
    children,

    jwt,
    appJwt,
    providerJwt,
    worklistViewerJwt,
    requestId,
    caseId,
    careQualityPatient,
    carequalityEnabled,

    mode,
    isApp,
    role,
    listMode,
    disabled,
    canOpenWorklist,
    withViewAllButton,
    withoutDelete,
    allowDownload,
    allowDownloadMedicalImages,
    canAddHiddenFileToCase,

    canMoveGroup,
    allowReorder,
    autoGrouping,
    canAddGroup,
    persistGroups,

    apiEndpoints,
    refreshUrl,
    patientName,

    setNotification,
    setLinkedStudies,

    removePersistedRecord,
    removeSelectedRecords,
    persistRecordInfo,

    setToBeUploaded,
    setIsUploading,
    setTotal,
    locations,
    adminUserEmail,
    dicomRouterOrigin,
    canRouteDicoms,
    canCreatePacs,
    showHiddenRecords
  }) => {
  const value = useMemo(() => ({
    jwt,
    appJwt,
    providerJwt,
    worklistViewerJwt,
    requestId,
    caseId,
    careQualityPatient,
    carequalityEnabled,

    mode,
    isApp,
    role,
    listMode,
    disabled,
    canOpenWorklist,
    withViewAllButton,
    withoutDelete,
    allowDownload,
    allowDownloadMedicalImages,
    canAddHiddenFileToCase,

    canMoveGroup,
    allowReorder,
    autoGrouping,
    canAddGroup,
    persistGroups,

    apiEndpoints,
    refreshUrl,
    patientName,

    setNotification,
    setLinkedStudies,

    removePersistedRecord,
    removeSelectedRecords,
    persistRecordInfo,

    setToBeUploaded,
    setIsUploading,
    setTotal,
    locations,
    adminUserEmail,
    dicomRouterOrigin,
    canRouteDicoms,
    canCreatePacs,
    showHiddenRecords
  }), [
    jwt, appJwt, providerJwt, worklistViewerJwt, requestId, caseId, careQualityPatient,carequalityEnabled,
    mode, isApp, role, listMode, disabled, canOpenWorklist, withViewAllButton, withoutDelete, allowDownload, allowDownloadMedicalImages,canAddHiddenFileToCase,
    canMoveGroup, allowReorder, autoGrouping, canAddGroup, persistGroups,
    apiEndpoints, refreshUrl, patientName,
    setNotification,

    locations,adminUserEmail,
    dicomRouterOrigin, canRouteDicoms, canCreatePacs, showHiddenRecords

    // Removed because they would trigger rerender and do not need to be updated:
    // persistRecordInfo, removePersistedRecord, removeSelectedRecords, setToBeUploaded, setIsUploading, setTotal, setLinkedStudies,
  ])

  return <UploaderConfigContext.Provider value={value}>{children}</UploaderConfigContext.Provider>

}